import React, { Component } from 'react';
import { Table } from 'antd';

class MachineDiagramListView extends Component {
    render() {
        const columns = [
            {
                title: 'Tipo',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: 'Detalle',
                dataIndex: 'details',
                key: 'details',
            },
            {
                title: 'Autor',
                dataIndex: 'author',
                key: 'author',
            },

        ];
        return (
            <Table
                columns={columns}
                expandedRowRender={record => (
                    <div>
                        <p style={{ margin: 0 }}>
                            {record.details}
                        </p>
                        { record.file != null && (
                            <a target="_blank" rel="noopener noreferrer" href={record.file}>
                                Descargar Archivo
                            </a>
                        )}
                    </div>
                )}
                dataSource={this.props.diagrams}
            />
        );
    }
}

export default MachineDiagramListView;



// WEBPACK FOOTER //
// ./src/components/views/MachineDiagramListView.js